import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { isNullOrUndefined, DateUtil, AbstractModel } from '@uzurv/core';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class DriverApprovalWorkQueueItem extends AbstractModel {
  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  rideSharingServiceId: number;

  @autoserialize
  hasProfileScreenshot: boolean;

  @autoserialize
  hasAvatarImage: boolean;

  @autoserialize
  hasVehicleImage: boolean;

  @autoserialize
  hasAddress: boolean;

  @autoserializeAs(Date)
  profileScreenshotModifiedDate: Date;

  @autoserializeAs(Date)
  avatarImageModifiedDate: Date;

  @autoserializeAs(Date)
  vehicleImageModifiedDate: Date;

  @autoserializeAs(Date)
  addressModifiedDate: Date;

  @autoserialize
  profileCompleted: boolean;

  @autoserialize
  profileApproved: boolean;

  @autoserializeAs(Date)
  profileCompletedDate: Date;

  @autoserialize
  profileScreenshotRejected: boolean;

  @autoserialize
  avatarImageRejected: boolean;

  @autoserialize
  vehicleImageRejected: boolean;

  @autoserialize
  isProfileRejected: boolean;

  @autoserializeAs(Date)
  profileRejectedDate: Date;

  @autoserialize
  rejectionComments: string;

  @autoserializeAs(Date)
  lastEmailReminderDate: Date;

  @autoserialize
  unsupportedState: boolean;

  /**** Serialization ****/

  static OnSerialized(instance: DriverApprovalWorkQueueItem, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.profileScreenshotModifiedDate)) {
      json.profileScreenshotModifiedDate = DateUtil.serializeDate(instance.profileScreenshotModifiedDate);
    }
    if (!isNullOrUndefined(instance.avatarImageModifiedDate)) {
      json.avatarImageModifiedDate = DateUtil.serializeDate(instance.avatarImageModifiedDate);
    }
    if (!isNullOrUndefined(instance.vehicleImageModifiedDate)) {
      json.vehicleImageModifiedDate = DateUtil.serializeDate(instance.vehicleImageModifiedDate);
    }
    if (!isNullOrUndefined(instance.profileCompletedDate)) {
      json.profileCompletedDate = DateUtil.serializeDate(instance.profileCompletedDate);
    }
    if (!isNullOrUndefined(instance.profileRejectedDate)) {
      json.profileRejectedDate = DateUtil.serializeDate(instance.profileRejectedDate);
    }
    if (!isNullOrUndefined(instance.lastEmailReminderDate)) {
      json.lastEmailReminderDate = DateUtil.serializeDate(instance.lastEmailReminderDate);
    }
    if (!isNullOrUndefined(instance.addressModifiedDate)) {
      json.addressModifiedDate = DateUtil.serializeDate(instance.addressModifiedDate);
    }
  }

  static OnDeserialized(instance: DriverApprovalWorkQueueItem, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['profileScreenshotModifiedDate'])) {
      instance.profileScreenshotModifiedDate = DateUtil.deserializeDate(json['profileScreenshotModifiedDate']);
    }
    if (!isNullOrUndefined(json['avatarImageModifiedDate'])) {
      instance.avatarImageModifiedDate = DateUtil.deserializeDate(json['avatarImageModifiedDate']);
    }
    if (!isNullOrUndefined(json['vehicleImageModifiedDate'])) {
      instance.vehicleImageModifiedDate = DateUtil.deserializeDate(json['vehicleImageModifiedDate']);
    }
    if (!isNullOrUndefined(json['profileCompletedDate'])) {
      instance.profileCompletedDate = DateUtil.deserializeDate(json['profileCompletedDate']);
    }
    if (!isNullOrUndefined(json['profileRejectedDate'])) {
      instance.profileRejectedDate = DateUtil.deserializeDate(json['profileRejectedDate']);
    }
    if (!isNullOrUndefined(json['lastEmailReminderDate'])) {
      instance.lastEmailReminderDate = DateUtil.deserializeDate(json['lastEmailReminderDate']);
    }
    if (!isNullOrUndefined(json['addressModifiedDate'])) {
      instance.addressModifiedDate = DateUtil.deserializeDate(json['addressModifiedDate']);
    }
  }
}
